var map = {
	"./fi-csv.svg": "1709",
	"./fi-doc.svg": "4a4e",
	"./fi-json.svg": "012e",
	"./fi-other.svg": "5bc8",
	"./fi-pdf.svg": "196e",
	"./fi-search.svg": "cacb",
	"./fi-txt.svg": "1fea",
	"./fi-xls.svg": "d68a",
	"./fi-xlsx.svg": "beac",
	"./fi-zip.svg": "7425"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cca4";